module.exports = __webpack_public_path__ + "static/media/company_logo.01171ae0.png";